import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // 核心邏輯：未登入時，強制重導向至登入頁面 (/login)
    // 同時透過 state 記錄使用者原本想去的網址 (from)，方便登入成功後直接跳轉回來，提升體驗
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 已登入，正常渲染目標頁面
  return <>{children}</>;
};